/* CONTROL LANDINGS */
import loaderMain from '@/modules/Landing/instances/loader-main'
import ageMain from '@/modules/Landing/instances/age-main'
import loaderF from '@/modules/Landing/instances/loader-f'
import loaderM from '@/modules/Landing/instances/loader-m'

import loaderActivity from '@/modules/Landing/instances/loader-activity'
import loaderActivityF from '@/modules/Landing/instances/loader-activity-f'
import loaderActivityM from '@/modules/Landing/instances/loader-activity-m'
import ageActivity from '@/modules/Landing/instances/age-activity'
import ageActivityF from '@/modules/Landing/instances/age-activity-f'
import ageActivityM from '@/modules/Landing/instances/age-activity-m'

import loaderYoga from '@/modules/Landing/instances/loader-yoga'
import loaderYogaF from '@/modules/Landing/instances/loader-yoga-f'
import ageYoga from '@/modules/Landing/instances/age-yoga'
import ageYogaF from '@/modules/Landing/instances/age-yoga-f'

import loaderWalking from '@/modules/Landing/instances/loader-walking'
import loaderWalkingLymphatic from '@/modules/Landing/instances/loader-walking-lymphatic'
import loaderWalkingF from '@/modules/Landing/instances/loader-walking-f'
import loaderWalkingOutdoor from '@/modules/Landing/instances/loader-walking-outdoor'
import loaderWalkingOutdoorF from '@/modules/Landing/instances/loader-walking-outdoor-f'
import loaderWalkingOutdoorFLymphatic from '@/modules/Landing/instances/loader-walking-outdoor-f-lymphatic'
import loaderNordicWalkingF from '@/modules/Landing/instances/loader-nordic-walking-f'
import loaderLymphaticWalkingF from '@/modules/Landing/instances/loader-lymphatic-walking-f'
import loaderLymphaticWalking from '@/modules/Landing/instances/loader-lymphatic-walking'
import loaderWalkingFUs from '@/modules/Landing/instances/loader-walking-f-us'
import loaderWalkingJapaneseF from '@/modules/Landing/instances/loader-walking-japanese-f'
import loaderTaiChiWalking from '@/modules/Landing/instances/loader-tai-chi-walking'
import loaderTaiChiWalkingLymphatic from '@/modules/Landing/instances/loader-tai-chi-walking-lymphatic'
import loaderTaiChiWalkingF from '@/modules/Landing/instances/loader-tai-chi-walking-f'
import loaderTaiChiWalkingFLymphatic from '@/modules/Landing/instances/loader-tai-chi-walking-f-lymphatic'
import loaderTaiChiMoveF from '@/modules/Landing/instances/loader-tai-chi-move-f'
import loaderTaiChiWalkingM from '@/modules/Landing/instances/loader-tai-chi-walking-m'
import loaderTaiChiWalkingFPr from '@/modules/Landing/instances/loader-tai-chi-walking-f-pr'
import loaderWalkingM from '@/modules/Landing/instances/loader-walking-m'
import ageWalking from '@/modules/Landing/instances/age-walking'
import ageWalkingLymphatic from '@/modules/Landing/instances/age-walking-lymphatic'
import ageWalkingInfluencer from '@/modules/Landing/instances/age-walking-influencer'
import ageWalkingF from '@/modules/Landing/instances/age-walking-f'
import ageWalkingOutdoor from '@/modules/Landing/instances/age-walking-outdoor'
import ageWalkingOutdoorF from '@/modules/Landing/instances/age-walking-outdoor-f'
import ageWalkingOutdoorFLymphatic from '@/modules/Landing/instances/age-walking-outdoor-f-lymphatic'
import ageWalkingFAl from '@/modules/Landing/instances/age-walking-f-al'
import ageNordicWalkingF from '@/modules/Landing/instances/age-nordic-walking-f'
import ageLymphaticWalkingF from '@/modules/Landing/instances/age-lymphatic-walking-f'
import ageLymphaticWalkingFPr from '@/modules/Landing/instances/age-lymphatic-walking-f-pr'
import ageLymphaticWalking from '@/modules/Landing/instances/age-lymphatic-walking'
import ageLymphaticWalkingPr from '@/modules/Landing/instances/age-lymphatic-walking-pr'
import ageWalkingFUs from '@/modules/Landing/instances/age-walking-f-us'
import agePrintableWalkingF from '@/modules/Landing/instances/age-printable-walking-f'
import ageWalkingJapaneseF from '@/modules/Landing/instances/age-walking-japanese-f'
import ageTaiChiWalking from '@/modules/Landing/instances/age-tai-chi-walking'
import ageTaiChiWalkingLymphatic from '@/modules/Landing/instances/age-tai-chi-walking-lymphatic'
import ageTaiChiWalkingF from '@/modules/Landing/instances/age-tai-chi-walking-f'
import ageTaiChiWalkingFLymphatic from '@/modules/Landing/instances/age-tai-chi-walking-f-lymphatic'
import ageTaiChiMoveF from '@/modules/Landing/instances/age-tai-chi-move-f'
import ageTaiChiWalkingFPr from '@/modules/Landing/instances/age-tai-chi-walking-f-pr'
import ageTaiChiWalkingPr from '@/modules/Landing/instances/age-tai-chi-walking-pr'
import ageTaiChiWalkingM from '@/modules/Landing/instances/age-tai-chi-walking-m'
import ageWalkingM from '@/modules/Landing/instances/age-walking-m'

import agePilatesF from '@/modules/Landing/instances/age-pilates-f'
import agePilatesFAl from '@/modules/Landing/instances/age-pilates-f-al'
import loaderPilatesF from '@/modules/Landing/instances/loader-pilates-f'
import ageChairWorkoutsM from '@/modules/Landing/instances/age-chair-workouts-m'
import ageChairTaiChiM from '@/modules/Landing/instances/age-chair-tai-chi-m'
import ageChairTaiChiF from '@/modules/Landing/instances/age-chair-tai-chi-f'
import ageChairTaiChiPr from '@/modules/Landing/instances/age-chair-tai-chi-pr'
import loaderChairWorkoutsM from '@/modules/Landing/instances/loader-chair-workouts-m'
import loaderChairTaiChiF from '@/modules/Landing/instances/loader-chair-tai-chi-f'

import ageCalisthenics from '@/modules/Landing/instances/age-calisthenics'
import ageCalisthenicsM from '@/modules/Landing/instances/age-calisthenics-m'
import ageCalisthenicsF from '@/modules/Landing/instances/age-calisthenics-f'
import loaderCalisthenics from '@/modules/Landing/instances/loader-calisthenics'
import loaderCalisthenicsM from '@/modules/Landing/instances/loader-calisthenics-m'
import loaderCalisthenicsF from '@/modules/Landing/instances/loader-calisthenics-f'

import loaderMilitaryM from '@/modules/Landing/instances/loader-military-m'
import ageMilitaryM from '@/modules/Landing/instances/age-military-m'
import loaderMilitaryCalisthenicsM from '@/modules/Landing/instances/loader-military-calisthenics-m'
import ageMilitaryCalisthenicsM from '@/modules/Landing/instances/age-military-calisthenics-m'
import ageMilitaryCalisthenicsMPr from '@/modules/Landing/instances/age-military-calisthenics-m-pr'
import loaderMilitaryCalisthenicsShM from '@/modules/Landing/instances/loader-military-calisthenics-sh-m'
import ageMilitaryCalisthenicsShM from '@/modules/Landing/instances/age-military-calisthenics-sh-m'
import loaderMilitaryCalisthenicsF from '@/modules/Landing/instances/loader-military-calisthenics-f'
import ageMilitaryCalisthenicsF from '@/modules/Landing/instances/age-military-calisthenics-f'
import ageMilitaryCalisthenicsFPr from '@/modules/Landing/instances/age-military-calisthenics-f-pr'
import loaderMilitaryCalisthenics from '@/modules/Landing/instances/loader-military-calisthenics'
import ageMilitaryCalisthenics from '@/modules/Landing/instances/age-military-calisthenics'
import ageMilitaryCalisthenicsPr from '@/modules/Landing/instances/age-military-calisthenics-pr'

import loaderTaiChiYogaM from '@/modules/Landing/instances/loader-tai-chi-yoga-m'
import loaderChairTaiChiM from '@/modules/Landing/instances/loader-chair-tai-chi-m'
import loaderChairTaiChiPr from '@/modules/Landing/instances/loader-chair-tai-chi-pr'
import ageTaiChiYogaM from '@/modules/Landing/instances/age-tai-chi-yoga-m'
import ageTaiChiYogaMAl from '@/modules/Landing/instances/age-tai-chi-yoga-m-al'
import ageTaiChiYogaMPr from '@/modules/Landing/instances/age-tai-chi-yoga-m-pr'
import loaderFMediterraneanDiet from '@/modules/Landing/instances/loader-f-mediterranean-diet'
import loaderFRamadan from '@/modules/Landing/instances/loader-f-ramadan'
import loaderTaiChiMGolfers from '@/modules/Landing/instances/loader-tai-chi-m-golfers'
import ageTaiChiMGolfers from '@/modules/Landing/instances/age-tai-chi-m-golfers'
import loaderFAntiInflammatoryDiet from '@/modules/Landing/instances/loader-f-anti-inflammatory-diet'
import loaderCarnivoreDietGs from '@/modules/Landing/instances/loader-carnivore-diet-gs'
import loaderFHashimotoDiet from '@/modules/Landing/instances/loader-f-hashimoto-diet'
import loaderFKoreanGlowDiet from '@/modules/Landing/instances/loader-f-korean-glow-diet'
import loaderJapaneseDiet from '@/modules/Landing/instances/loader-japanese-diet'
import loaderFPostmenopausal from '@/modules/Landing/instances/loader-f-postmenopausal'
import ageFPostmenopausal from '@/modules/Landing/instances/age-f-postmenopausal'

import loaderPrintableChairYoga from '@/modules/Landing/instances/loader-printable-chair-yoga'
import agePrintableChairYoga from '@/modules/Landing/instances/age-printable-chair-yoga'

/* CREATIVES */
import creativesBellytype from '@/modules/Landing/instances/creatives/creatives-bellytype'
import creativesSpreadsheet from '@/modules/Landing/instances/creatives/creatives-spreadsheet'
import creativesCalorieCalculator from '@/modules/Landing/instances/creatives/creatives-calorie-calculator'
import creativesExercise from '@/modules/Landing/instances/creatives/creatives-exercise'
import creativesWeightLoss from '@/modules/Landing/instances/creatives/creatives-weight-loss'
import creativesFasting from '@/modules/Landing/instances/creatives/creatives-fasting'
import creativesDemgen from '@/modules/Landing/instances/creatives/creatives-demgen'
import creativesSpreadsheetWalking from '@/modules/Landing/instances/creatives/creatives-spreadsheet-walking'
import creativesBestDiet from '@/modules/Landing/instances/creatives/creatives-best-diet'
import loaderWaterBalanceF from '@/modules/Landing/instances/loader-water-balance-f'
import loaderWaterBalanceM from '@/modules/Landing/instances/loader-water-balance-m'
import creativesSearchWallPilates from '@/modules/Landing/instances/creatives/creatives-search-wall-pilates'
import creativesSearchYoga from '@/modules/Landing/instances/creatives/creatives-search-yoga'
import creativesSearchTaiChiWalkingGs from '@/modules/Landing/instances/creatives/creatives-search-tai-chi-walking-gs'
import creativesSearchTaiChiGs from '@/modules/Landing/instances/creatives/creatives-search-tai-chi-gs'
import creativesFastingGs from '@/modules/Landing/instances/creatives/creatives-fasting-gs'
import loaderTaiChiF from '@/modules/Landing/instances/loader-tai-chi-f'
import ageTaiChiF from '@/modules/Landing/instances/age-tai-chi-f'
import ageTaiChi from '@/modules/Landing/instances/age-tai-chi'
import ageTaiChiPr from '@/modules/Landing/instances/age-tai-chi-pr'
import loaderTaiChi from '@/modules/Landing/instances/loader-tai-chi'
import socialProof from '@/modules/Landing/instances/social-proof'
import socialProofTaiChi from '@/modules/Landing/instances/social-proof-tai-chi'
import articleMain from '@/modules/Landing/instances/article-main'

export const instances = {
	/* CONTROL LANDINGS */
	'social-proof': socialProof,
	'social-proof-tai-chi': socialProofTaiChi,
	'loader-main': loaderMain,
	'age-main': ageMain,
	'article-main': articleMain,
	'loader-f': loaderF,
	'loader-m': loaderM,

	'loader-activity': loaderActivity,
	'loader-activity-f': loaderActivityF,
	'loader-activity-m': loaderActivityM,
	'age-activity': ageActivity,
	'age-activity-f': ageActivityF,
	'age-activity-m': ageActivityM,

	'loader-yoga': loaderYoga,
	'loader-yoga-f': loaderYogaF,
	'age-yoga': ageYoga,
	'age-yoga-f': ageYogaF,

	'loader-walking': loaderWalking,
	'loader-walking-lymphatic': loaderWalkingLymphatic,
	'loader-walking-f': loaderWalkingF,
	'loader-walking-outdoor': loaderWalkingOutdoor,
	'loader-walking-outdoor-f': loaderWalkingOutdoorF,
	'loader-walking-outdoor-f-lymphatic': loaderWalkingOutdoorFLymphatic,
	'loader-nordic-walking-f': loaderNordicWalkingF,
	'loader-lymphatic-walking-f': loaderLymphaticWalkingF,
	'loader-lymphatic-walking': loaderLymphaticWalking,
	'loader-walking-f-us': loaderWalkingFUs,
	'loader-walking-japanese-f': loaderWalkingJapaneseF,
	'loader-tai-chi-walking': loaderTaiChiWalking,
	'loader-tai-chi-walking-lymphatic': loaderTaiChiWalkingLymphatic,
	'loader-tai-chi-walking-f': loaderTaiChiWalkingF,
	'loader-tai-chi-walking-f-lymphatic': loaderTaiChiWalkingFLymphatic,
	'loader-tai-chi-move-f': loaderTaiChiMoveF,
	'loader-tai-chi-walking-m': loaderTaiChiWalkingM,
	'loader-tai-chi-walking-f-pr': loaderTaiChiWalkingFPr,
	'loader-tai-chi-f': loaderTaiChiF,
	'loader-tai-chi': loaderTaiChi,
	'loader-walking-m': loaderWalkingM,
	'age-walking': ageWalking,
	'age-walking-lymphatic': ageWalkingLymphatic,
	'age-walking-influencer': ageWalkingInfluencer,
	'age-walking-f': ageWalkingF,
	'age-walking-outdoor': ageWalkingOutdoor,
	'age-walking-outdoor-f': ageWalkingOutdoorF,
	'age-walking-outdoor-f-lymphatic': ageWalkingOutdoorFLymphatic,
	'age-walking-f-al': ageWalkingFAl,
	'age-nordic-walking-f': ageNordicWalkingF,
	'age-lymphatic-walking-f': ageLymphaticWalkingF,
	'age-lymphatic-walking-f-pr': ageLymphaticWalkingFPr,
	'age-lymphatic-walking': ageLymphaticWalking,
	'age-lymphatic-walking-pr': ageLymphaticWalkingPr,
	'age-walking-f-us': ageWalkingFUs,
	'age-printable-walking-f': agePrintableWalkingF,
	'age-walking-japanese-f': ageWalkingJapaneseF,
	'age-tai-chi-walking': ageTaiChiWalking,
	'age-tai-chi-walking-lymphatic': ageTaiChiWalkingLymphatic,
	'age-tai-chi-walking-f': ageTaiChiWalkingF,
	'age-tai-chi-walking-f-lymphatic': ageTaiChiWalkingFLymphatic,
	'age-tai-chi-move-f': ageTaiChiMoveF,
	'age-tai-chi-walking-f-pr': ageTaiChiWalkingFPr,
	'age-tai-chi-walking-pr': ageTaiChiWalkingPr,
	'age-tai-chi-walking-m': ageTaiChiWalkingM,
	'age-tai-chi-f': ageTaiChiF,
	'age-walking-m': ageWalkingM,
	'loader-f-mediterranean-diet': loaderFMediterraneanDiet,
	'loader-f-anti-inflammatory-diet': loaderFAntiInflammatoryDiet,
	'loader-f-hashimoto-diet': loaderFHashimotoDiet,
	'loader-f-korean-glow-diet': loaderFKoreanGlowDiet,
	'loader-f-postmenopausal': loaderFPostmenopausal,
	'age-f-postmenopausal': ageFPostmenopausal,
	'age-tai-chi': ageTaiChi,
	'age-tai-chi-pr': ageTaiChiPr,

	'age-pilates-f': agePilatesF,
	'age-pilates-f-al': agePilatesFAl,
	'loader-pilates-f': loaderPilatesF,
	'age-chair-workouts-m': ageChairWorkoutsM,
	'age-chair-tai-chi-m': ageChairTaiChiM,
	'age-chair-tai-chi-f': ageChairTaiChiF,
	'age-chair-tai-chi-pr': ageChairTaiChiPr,
	'loader-chair-workouts-m': loaderChairWorkoutsM,
	'loader-chair-tai-chi-f': loaderChairTaiChiF,

	'age-calisthenics': ageCalisthenics,
	'age-calisthenics-m': ageCalisthenicsM,
	'age-calisthenics-f': ageCalisthenicsF,
	'loader-calisthenics': loaderCalisthenics,
	'loader-calisthenics-m': loaderCalisthenicsM,
	'loader-calisthenics-f': loaderCalisthenicsF,

	'age-military-m': ageMilitaryM,
	'loader-military-m': loaderMilitaryM,
	'age-military-calisthenics-m': ageMilitaryCalisthenicsM,
	'age-military-calisthenics-m-pr': ageMilitaryCalisthenicsMPr,
	'loader-military-calisthenics-m': loaderMilitaryCalisthenicsM,
	'age-military-calisthenics-sh-m': ageMilitaryCalisthenicsShM,
	'loader-military-calisthenics-sh-m': loaderMilitaryCalisthenicsShM,
	'age-military-calisthenics-f': ageMilitaryCalisthenicsF,
	'age-military-calisthenics-f-pr': ageMilitaryCalisthenicsFPr,
	'loader-military-calisthenics': loaderMilitaryCalisthenics,
	'age-military-calisthenics': ageMilitaryCalisthenics,
	'age-military-calisthenics-pr': ageMilitaryCalisthenicsPr,
	'loader-military-calisthenics-f': loaderMilitaryCalisthenicsF,

	'loader-tai-chi-yoga-m': loaderTaiChiYogaM,
	'age-tai-chi-yoga-m': ageTaiChiYogaM,
	'age-tai-chi-yoga-m-al': ageTaiChiYogaMAl,
	'age-tai-chi-yoga-m-pr': ageTaiChiYogaMPr,
	'loader-water-balance-f': loaderWaterBalanceF,
	'loader-water-balance-m': loaderWaterBalanceM,
	'loader-f-ramadan': loaderFRamadan,
	'loader-chair-tai-chi-m': loaderChairTaiChiM,
	'loader-chair-tai-chi-pr': loaderChairTaiChiPr,
	'loader-tai-chi-m-golfers': loaderTaiChiMGolfers,
	'age-tai-chi-m-golfers': ageTaiChiMGolfers,
	'loader-carnivore-diet-gs': loaderCarnivoreDietGs,
	'loader-japanese-diet': loaderJapaneseDiet,

	'loader-printable-chair-yoga': loaderPrintableChairYoga,
	'age-printable-chair-yoga': agePrintableChairYoga,

	/* CREATIVES */
	'creatives-bellytype': creativesBellytype,
	'creatives-spreadsheet': creativesSpreadsheet,
	'creatives-calorie-calculator': creativesCalorieCalculator,
	'creatives-exercise': creativesExercise,
	'creatives-weight-loss': creativesWeightLoss,
	'creatives-fasting': creativesFasting,
	'creatives-spreadsheet-walking': creativesSpreadsheetWalking,
	'creatives-best-diet': creativesBestDiet,
	'creatives-demgen': creativesDemgen,

	'creatives-search-wall-pilates': creativesSearchWallPilates,
	'creatives-search-yoga': creativesSearchYoga,
	'creatives-search-tai-chi-walking-gs': creativesSearchTaiChiWalkingGs,
	'creatives-search-tai-chi-gs': creativesSearchTaiChiGs,
	'creatives-fasting-gs': creativesFastingGs,
}
